"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighlightSynchronizer = void 0;
exports.createHighlightSynchronizer = createHighlightSynchronizer;
/**
 * Build uniform timings if precise per-word timings are absent.
 */
function buildUniformTimings(tokens, duration) {
    const wordTokens = tokens.filter((t) => t.isWord);
    const count = wordTokens.length || 1;
    const slice = duration / count;
    return wordTokens.map((t, i) => ({
        wordIndex: i,
        start: Math.floor(i * slice),
        end: Math.floor((i + 1) * slice),
    }));
}
class HighlightSynchronizer {
    constructor(cfg) {
        this.tokens = cfg.tokens;
        const wordTokens = [];
        this.tokens.forEach((t, idx) => {
            if (t.isWord)
                wordTokens.push(idx);
        });
        this.wordTokenIndices = wordTokens;
        if (cfg.wordTimings && cfg.wordTimings.length > 0) {
            this.timings = cfg.wordTimings.slice().sort((a, b) => a.start - b.start);
        }
        else {
            this.timings = buildUniformTimings(this.tokens, cfg.duration);
        }
    }
    /**
     * Get active word info for current playback position (ms)
     */
    getActiveWord(positionMs) {
        if (this.timings.length === 0)
            return null;
        // Binary search for performance on large texts
        let lo = 0, hi = this.timings.length - 1, mid = 0;
        while (lo <= hi) {
            mid = (lo + hi) >> 1;
            const timing = this.timings[mid];
            if (positionMs < timing.start)
                hi = mid - 1;
            else if (positionMs >= timing.end)
                lo = mid + 1;
            else
                break;
        }
        const timing = this.timings[mid];
        if (!timing || positionMs < timing.start || positionMs >= timing.end) {
            // Fallback to closest previous
            const idx = Math.max(0, Math.min(this.timings.length - 1, hi));
            const t = this.timings[idx];
            const tokenIndex = this.wordTokenIndices[t.wordIndex];
            return {
                tokenIndex,
                wordIndex: t.wordIndex,
                text: this.tokens[tokenIndex].text,
                progressInWord: 1,
            };
        }
        const tokenIndex = this.wordTokenIndices[timing.wordIndex];
        const token = this.tokens[tokenIndex];
        const progressInWord = (positionMs - timing.start) / (timing.end - timing.start || 1);
        return {
            tokenIndex,
            wordIndex: timing.wordIndex,
            text: token.text,
            progressInWord: Math.max(0, Math.min(1, progressInWord)),
        };
    }
}
exports.HighlightSynchronizer = HighlightSynchronizer;
/** Lightweight helper */
function createHighlightSynchronizer(cfg) {
    return new HighlightSynchronizer(cfg);
}
//# sourceMappingURL=highlightSync.js.map